import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueLuxon from 'vue-luxon'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  VueLuxon,
  render: h => h(App)
}).$mount('#app')
